import React from 'react'
import { useParams } from 'react-router-dom'
import PDFViewer from 'pdf-viewer-reactjs'
import Footer from '../Components/Footer'
import { Link } from 'react-router-dom'
import GoToTop from '../Components/GoToTop'

export default function Notes() {
    let { subject, src } = useParams()
    alert('Change page if you come across a blank sheet.')
    return (
        <div className='pdfviewer'>
            <Link to={`/Notes/${subject}/${src}`} target='_blank'><button>Download PDF</button></Link>
            <PDFViewer className='pdf'
                document={{
                    url: `/Notes/${subject}/${src}`
                }}
                alert={(err) => (
                    <div
                        style={{
                            color: '#fa5b35',
                            backgroundColor: '#0c0c0c',
                        }}>
                        <h3 style={{ fontWeight: 'bolder' }}>Failed To load !!!</h3>
                        <h6>{err.message}</h6>
                    </div>
                )}
                navbarOnTop
            />
            <h3 style={{color: 'white', textAlign: 'center'}}>Change page from <span style={{cursor: 'pointer', color: 'springgreen'}} onClick={()=>{window.scroll({top: 0, left: 0, behavior: 'smooth' })}}>top</span> if this is blank.</h3>
            <Footer />
            <GoToTop />
        </div>
    )
}
